module.exports = __webpack_public_path__ + "static/media/DSC09608.f8e8c699.jpg";